import { Button } from 'antd';
import styled from 'styled-components';

import { GreenColors, NeutralColors } from '@/theme';

/**
 * Green confirm button matching the standardized confirmation-modal pattern.
 * Use inside declarative `Modal` footers that can't go through
 * `showConfirmModal`. Disabled state keeps the default antd styling.
 */
export const ConfirmButton = styled(Button)`
  &:not(:disabled):not(.ant-btn-disabled) {
    background-color: ${GreenColors[60]};
    border-color: ${GreenColors[60]};
    color: ${NeutralColors[0]};

    &:hover {
      background-color: ${GreenColors[70]};
      border-color: ${GreenColors[70]};
      color: ${NeutralColors[0]};
    }
  }
`;
